export { FrontendBootcampPage as default } from 'features/Marketing/LandingV1'
